// Privacyrechten (0036; docs/DESIGN.md §8.PR, docs/PRIVACY-rechten.md): alles downloaden (ZIP),
// iemand uit het gezin halen (7 dagen terugzetten) en het gezinsbord verwijderen (30 dagen
// bedenktijd). Sleutels in `a.privacyRights.*` (app.nl.ts); de server leest `summary` en
// `formerMember` voor de export en het anonimiseren (in de taal van het gezin).
// Toon: je-vorm, rustig, geen juridische woorden op knoppen; wat onomkeerbaar is, staat er eerlijk.
export const appPrivacyRightsNl = {
    title: 'Jouw gegevens',
    intro: 'Alles downloaden, iemand uit het gezin halen of het gezinsbord verwijderen. Het zijn jullie gegevens.',
    /** Ingang in Instellingen. */
    entry: 'Jouw gegevens',
    entryBody: 'Alles downloaden, iemand uit het gezin halen, het gezinsbord verwijderen.',
    // ---- Alles downloaden (ZIP, alleen de eigenaar) ----------------------------------------------
    exportTitle: 'Alles downloaden',
    exportBody: 'Eén ZIP-bestand met alles van jullie gezin: leden, agenda, taken, eten, berichten, gegevens over foto’s en de keuzes bij Wat past bij ons gezin. Met een leesbare samenvatting erbij.',
    exportOwnerOnly: 'Alleen de eigenaar van het gezinsbord kan alles downloaden.',
    exportStart: 'Download voorbereiden',
    exportPending: 'We maken het bestand. Dat duurt meestal minder dan een minuut.',
    exportReady: 'Klaar · {size} · te downloaden tot {time}',
    exportOnce: 'Je kunt het bestand één keer downloaden. Daarna wissen we het.',
    exportDownload: 'Downloaden',
    exportDownloaded: 'Gedownload op {time}',
    exportExpired: 'Verlopen op {time}',
    exportFailed: 'Het lukte niet om het bestand te maken. Probeer het opnieuw.',
    exportAgain: 'Opnieuw voorbereiden',
    exportMailed: 'Alle ouders krijgen een mail dat er een download klaarstaat.',
    exportStarted: 'We maken het bestand',
    exportSaved: 'Het bestand staat in je downloads',
    /** Alleen je eigen gegevens (JSON), ook voor een andere ouder of een kind van 16+. */
    mineTitle: 'Alleen jouw eigen gegevens',
    mineBody: 'Je eigen gegevens en het gezinsprofiel dat voor jou geldt, als bestand (JSON).',
    mineButton: 'Mijn gegevens downloaden',
    // ---- Iemand uit het gezin halen --------------------------------------------------------------
    removeTitle: 'Iemand uit het gezin halen',
    removeBody: 'Bijvoorbeeld een kind dat het huis uit is of een ex-partner. Dat doe je bij Gezin: open de persoon en kies Uit het gezin halen.',
    removeToMembers: 'Naar Gezin',
    removeButton: 'Uit het gezin halen',
    removeConfirmTitle: '{name} uit het gezin halen?',
    removeConfirmNow: '{name} verdwijnt meteen uit de app en van het bord. Heeft {name} een eigen inlog, dan werkt die niet meer voor dit gezin.',
    removeConfirmLater: 'Je kunt dit 7 dagen terugzetten. Daarna maken we {name} anoniem: de naam wordt “Voormalig gezinslid”, foto, geboortedatum en bijzondere gegevens (geloof, gezondheid, school) verdwijnen, net als toekomstige afspraken en taken. Wat al gebeurd is, blijft zonder naam staan.',
    removeConfirmProfile: 'Eigen keuzes bij Wat past bij ons gezin en het weer worden meteen gewist en komen bij terugzetten niet terug.',
    removeConfirmButton: 'Uit het gezin halen',
    // Golf 8 review r2 (§2.9, KD-11): dezelfde vragen voor een huis (studenten, woongroep, stel,
    // alleen); {former} = "Voormalig huisgenoot" of "Oud-bewoner" uit de woordenset.
    removeButtonHouse: 'Uit huis halen',
    removeConfirmTitleHouse: '{name} uit huis halen?',
    removeConfirmNowHouse: '{name} verdwijnt meteen uit de app en van het bord. Heeft {name} een eigen inlog, dan werkt die niet meer voor dit huis.',
    removeConfirmLaterHouse: 'Je kunt dit 7 dagen terugzetten. Daarna maken we {name} anoniem: de naam wordt “{former}”, foto en persoonlijke gegevens verdwijnen, net als toekomstige afspraken en taken. Wat al gebeurd is (ook uitgaven), blijft zonder naam staan.',
    removeConfirmProfileHouse: 'Eigen keuzes van {name} (zoals eten en het weer) worden meteen gewist en komen bij terugzetten niet terug.',
    removeConfirmButtonHouse: 'Uit huis halen',
    removeConfirmAnywayHouse: 'Toch uit huis halen',
    removedHouse: '{name} is uit huis gehaald',
    /** Vóór het bevestigen: agendalinks en tablets van deze persoon (review g4 sec r1). */
    removeConfirmLinks: 'Agendalinks die {name} maakte (Google, Outlook of Apple Agenda) stoppen meteen.',
    removeConfirmDevices: '{name} koppelde deze tablets. Die blijven werken tot je ze ontkoppelt:',
    removeUnpairDevice: 'Tablet ontkoppelen',
    /** {date} = "12 sep". Onder de naam van een tablet in het verwijderscherm. */
    removeDevicePaired: 'gekoppeld op {date}',
    removeDeviceUnpaired: '{name} is ontkoppeld',
    removed: '{name} is uit het gezin gehaald',
    removedListTitle: 'Uit het gezin gehaald',
    removedUntil: 'Terugzetten kan tot {time}',
    removedHadLogin: 'Inlog ingetrokken',
    undo: 'Terugzetten',
    undone: '{name} is terug in het gezin',
    undoneNoLogin: '{name} is terug in het gezin. De inlog kon niet terug; nodig opnieuw uit.',
    errorIsOwner: 'De eigenaar kan niet uit het gezin gehaald worden.',
    errorIsSelf: 'Je kunt jezelf niet uit het gezin halen.',
    errorNeedsOwner: 'Alleen de eigenaar kan een andere ouder uit het gezin halen.',
    errorWindowClosed: 'De 7 dagen zijn voorbij; terugzetten kan niet meer.',
    errorAlreadyRemoved: 'Deze persoon is al uit het gezin gehaald.',
    errorDeletionUnavailable: 'Verwijderen kan nu even niet. Er is niets gepland; probeer het later opnieuw of mail ons.',
    errorConfirmName: 'De naam klopt niet. Typ de naam van je gezinsbord precies over.',
    errorExportGone: 'Dit bestand is er niet meer. Bereid een nieuwe download voor.',
    /** Bij "Gegevens downloaden" in Instellingen: de ZIP staat op Jouw gegevens. */
    zipHint: 'Alles als één ZIP met een leesbare samenvatting:',
    // ---- Het gezinsbord verwijderen (alleen de eigenaar) -----------------------------------------
    deleteTitle: 'Het gezinsbord verwijderen',
    deleteBody: 'Alles van jullie gezin wordt gewist: agenda, taken, eten, berichten, foto’s en instellingen. Je hebt 30 dagen bedenktijd.',
    deleteOwnerOnly: 'Alleen de eigenaar kan het gezinsbord verwijderen.',
    deleteButton: 'Gezinsbord verwijderen…',
    deleteConfirmTitle: 'Het gezinsbord verwijderen?',
    deletePoints: [
        'Over 30 dagen wissen we alles van {household}. Dat is daarna niet terug te halen.',
        'Tot die dag kun je het tegenhouden met Toch niet verwijderen.',
        'De tablets tonen tot dan een rustige melding en stoppen daarna.',
        'Alle ouders krijgen een mail, nu en als alles gewist is.',
    ],
    deleteExportFirst: 'Eerst alles downloaden?',
    deleteExportFirstBody: 'Maak een kopie voordat je verwijdert. Dat kan ook later, tot de dag zelf.',
    deleteTypeName: 'Typ de naam van je gezinsbord om te bevestigen',
    deleteTypeNameHint: 'Precies: {household}',
    deleteConfirmButton: 'Verwijderen over 30 dagen',
    deleteScheduled: 'Het gezinsbord wordt verwijderd op {date}',
    deleteScheduledBody: 'Tot die dag werkt alles gewoon. Daarna wissen we alles en krijgen alle ouders een mail.',
    deleteScheduledByAdmin: 'Gepland door AMUMIN, op jullie verzoek.',
    cancelDelete: 'Toch niet verwijderen',
    cancelled: 'Het gezinsbord blijft bestaan',
    /** Banner bovenaan de app, voor iedereen in het gezin. */
    banner: 'Dit gezinsbord wordt verwijderd op {date}.',
    bannerOwner: 'Toch niet verwijderen',
    bannerOthers: 'Alleen de eigenaar kan dit tegenhouden.',
    bannerMore: 'Meer weten',
    // ---- Wat overblijft na het anonimiseren (server, taal van het gezin) --------------------------
    formerMember: 'Voormalig gezinslid',
    formerMemberShared: 'Voormalig huisgenoot',
    formerMemberResident: 'Oud-bewoner',
    // ---- Leesbare samenvatting in de ZIP (server, taal van het gezin) -----------------------------
    summary: {
        title: 'Gegevens van {household}',
        intro: 'Dit zijn alle gegevens van jullie gezinsbord op {date}, zoals AMUMIN ze bewaart. Elk onderdeel staat in een eigen JSON-bestand; dat kun je openen met een teksteditor of inlezen in een ander programma.',
        fileHeader: 'Bestand',
        whatHeader: 'Wat staat erin',
        countHeader: 'Regels',
        membersTitle: 'Leden',
        memberFormer: 'voormalig gezinslid',
        memberArchived: 'niet meer actief',
        notIncludedTitle: 'Wat er niet in staat',
        notIncluded: 'Geheimen (wachtwoorden, pincodes, koppelcodes en inloggegevens van tablets), technische logboeken en tijdelijke kopieën van antwoorden van andere diensten. De foto’s en opnames zelf zitten er niet in; wel wanneer en hoe groot ze zijn.',
        rightsTitle: 'Jullie rechten',
        rights: 'Je kunt gegevens laten verbeteren in de app zelf, iemand uit het gezin halen of het hele gezinsbord verwijderen bij Instellingen › Jouw gegevens. Vragen of een klacht? Neem contact op met AMUMIN (zie de privacyverklaring in de app); je mag ook een klacht indienen bij de Autoriteit Persoonsgegevens.',
        accountTitle: 'Jouw account',
        accountBody: 'Het e-mailadres waarmee je inlogt en wanneer je account is gemaakt (account.json).',
        domains: {
            household: {
                title: 'Gezin en tablets',
                body: 'Het gezinsbord met de soort huishouden, de leden, inlogs (zonder wachtwoorden) en hun schermkeuzes, kamers, tablets, uitnodigingen en de grove locatie.',
            },
            profile: {
                title: 'Wat past bij ons gezin',
                body: 'Keuken, geloof, eten en bijzondere dagen, met alle toestemmingen (ook ingetrokken).',
            },
            calendar: {
                title: 'Agenda',
                body: 'Afspraken, herhalingen, wie er meegaat, ritten, herinneringen en gekoppelde agenda’s.',
            },
            tasks: {
                title: 'Taken en beloningen',
                body: 'Taken, wie ze deed, punten, beloningen en aanvragen.',
            },
            food: { title: 'Eten', body: 'Boodschappen, recepten, weekmenu en voorraad.' },
            // Golf 8 (0049): Kosten delen.
            costs: {
                title: 'Kosten delen',
                body: 'Uitgaven met hun verdeling, verrekeningen en afsluitingen van het huis.',
            },
            family: {
                title: 'Familie en berichten',
                body: 'Wensenlijstjes, contacten, gekoppelde families, gesprekken en berichten.',
            },
            rooms: {
                title: 'Kamers en schoonmaak',
                body: 'Wie in welke kamer slaapt, klussen, het beurtrooster (afwezig en ruilen), het schoonmaaklog en kindsloten (zonder de code).',
            },
            media: {
                title: 'Foto’s en opnames',
                body: 'Gegevens over foto’s en opnames: soort, grootte en datum.',
            },
            care: {
                title: 'Check-in en familiekring',
                body: "Wanneer 'Alles goed' getikt is, meldingen en wie ze kreeg, pauzes, de kring met rechten en de toestemmingen van de oudere.",
            },
            weather_prayer: {
                title: 'Weer en gebedstijden',
                body: 'Instellingen voor het weeradvies en de gebedstijden.',
            },
            growth: {
                title: 'Groei',
                body: 'Lengte en gewicht met de toestemmingen, als jullie dit gebruiken.',
            },
            school: { title: 'School', body: 'Vakken en resultaten, als jullie dit gebruiken.' },
            security: {
                title: 'Beveiliging',
                body: 'Vertrouwde netwerken, beveiligingsmeldingen en het auditlog (wie wat deed, zonder inhoud).',
            },
            privacy: {
                title: 'Privacyverzoeken',
                body: 'Downloads zoals deze, wie uit het gezin is gehaald en een geplande verwijdering.',
            },
            // 0065: abonnement, geschiedenis en facturen.
            billing: {
                title: 'Abonnement en facturen',
                body: 'Je abonnement en proefmaand, wat er veranderde (opzeggen, betalen) en de facturen. Facturen bewaren we 7 jaar, ook na het verwijderen (wettelijke plicht).',
            },
            // 0068: Gezond op gewicht (persoonlijk).
            kompas: {
                title: 'Gezond op gewicht',
                body: 'Alleen van jezelf: je toestemming, profiel en doel, wat je at, water, beweging, wegingen en je tegel op het bord. Staat in je eigen omgeving; niemand anders ziet het.',
            },
            // 0069: Geldzaken (alleen in de eigen omgeving van een volwassene).
            money: {
                title: 'Geldzaken',
                body: 'Je eigen ruimtes, transacties (de IBAN van een ander afgeschermd), regels, doelen en bezit. Alleen in de download van je eigen omgeving.',
            },
        },
    },
};
//# sourceMappingURL=privacyRights.nl.js.map